import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Site, formatNumber } from '@debbie/common/dist/index.js';
import { PaymentPlanEntryStatus, PaymentPlanStatus, getCurrentPaymentPlan, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { PaymentMethodStatus } from '@debbie/common/dist/payment-methods/index.js';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as paymentPlansLib from '@debbie/cortex/dist/api/payment-plans.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { Badge, Loading, Modal, PaymentPlanCreator } from '..//index.js';
import THEME from '../../theme.js';
import ArrowRight from '../Icons/ArrowRight.js';
import CreditCard from '../Icons/CreditCard.js';
import PlusCircle from '../Icons/PlusCircle.js';
import RefreshCcw from '../Icons/RefreshCcw.js';
import X from '../Icons/X.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { paymentPlansEntity, usePaymentPlansByCaseId, } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
const CasePaymentPlan = (props) => {
    const lang = useSelector((s) => s.lang);
    const meRole = useSelector(selectRole);
    const site = useSelector((s) => s.site);
    const tenantId = useSelector(selectTenantId);
    const paymentPlansLoadable = usePaymentPlansByCaseId(props.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const caseVouchers_ = useCaseVouchersByCase(props.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const [state, setState] = useState({
        deletingPaymentPlan: false,
    });
    const [paymentPlanModalOpen, setPaymentPlanModalOpen] = useState(false);
    const isMeCaseWorker = meRole && isCaseworker(meRole);
    const paymentPlan = paymentPlans && getCurrentPaymentPlan(paymentPlans);
    const deletePaymentPlan = async (e) => {
        if (paymentPlan) {
            setState({ ...state, deletingPaymentPlan: true });
            e.stopPropagation();
            e.preventDefault();
            await paymentPlansLib.del(paymentPlan.paymentPlanId);
            q.invalidate(keys.write.modify(paymentPlansEntity, paymentPlan.paymentPlanId));
            setState({ ...state, deletingPaymentPlan: false });
        }
    };
    const nextEntry = paymentPlan?.plan.find((entry) => moment(entry.date).isAfter(moment()));
    return (React.createElement(React.Fragment, null,
        paymentPlan ? (React.createElement(PaymentPlan, { onClick: () => site === Site.Caseworker &&
                setPaymentPlanModalOpen(!paymentPlanModalOpen), style: {
                cursor: site === Site.Caseworker ? 'pointer' : 'initial',
            } },
            React.createElement("h3", { className: "pp-title" },
                lang.paymentPlans.paymentPlan,
                ' ',
                React.createElement("small", null,
                    React.createElement(RefreshCcw, { style: { height: '25px' } }),
                    ' ',
                    paymentPlan.plan.filter((entry) => [PaymentPlanEntryStatus.SETTLED].includes(entry.status)).length,
                    "/",
                    paymentPlan.plan.length)),
            React.createElement("div", { style: { fontSize: '.8em' } },
                React.createElement(Badge, { theme: paymentPlan.status === PaymentPlanStatus.ACTIVE
                        ? THEME.SUCCESS
                        : 'grey' }, lang.paymentPlans[paymentPlan.status] || paymentPlan.status),
                ' ',
                paymentPlan.paymentMethodStatus === PaymentMethodStatus.SAVED && (React.createElement(CreditCard, { style: {
                        height: '13px',
                        width: '16px',
                        margin: '0.2em 2px -0.2em 0',
                    } })),
                paymentPlan.status === PaymentPlanStatus.ACTIVE && nextEntry ? (React.createElement("b", { style: {
                        display: 'inline-block',
                        fontSize: '0.8em',
                        margin: '0',
                    } },
                    formatNumber(nextEntry.amount || 0),
                    ' ',
                    React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0' } }),
                    ' ',
                    moment(nextEntry.date).format('DD.MM'))) : null),
            React.createElement("p", { className: "pp-interval" },
                paymentPlan.plan.length > 0 && (React.createElement(React.Fragment, null,
                    moment(paymentPlan.plan[0].date).format(THEME.DATE_FORMAT_SHORT),
                    ' ',
                    React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0' } }),
                    ' ',
                    moment(paymentPlan.plan[paymentPlan.plan.length - 1].date).format(THEME.DATE_FORMAT_SHORT))),
                isMeCaseWorker && (React.createElement(React.Fragment, null, state.deletingPaymentPlan ? (React.createElement("div", { className: "pp-delete" },
                    React.createElement(Loading, { width: "11px" }))) : (React.createElement("div", { className: "pp-delete", onClick: deletePaymentPlan },
                    React.createElement(X, null)))))))) : (caseVouchers &&
            site === Site.Caseworker && (React.createElement(PaymentPlan, { onClick: () => site === Site.Caseworker &&
                setPaymentPlanModalOpen(!paymentPlanModalOpen), style: {
                cursor: site === Site.Caseworker ? 'pointer' : 'initial',
            } },
            React.createElement("h3", { className: "pp-title" }, lang.paymentPlans.paymentPlan),
            React.createElement("p", { className: "pp-interval" },
                React.createElement(PlusCircle, { style: {
                        margin: '.2em 0 -.2em',
                    } }),
                ' ',
                lang.paymentPlans.createNewPaymentPlan)))),
        paymentPlanModalOpen && (React.createElement(Modal, { header: lang.paymentPlans.paymentPlan, onToggle: () => setPaymentPlanModalOpen(!paymentPlanModalOpen) }, caseVouchers && tenantId && (React.createElement(PaymentPlanCreator, { tenantId: tenantId, caseId: props.caseId, caseVouchers: caseVouchers }))))));
};
export default CasePaymentPlan;
const PaymentPlan = styled.div `
  border-radius: 4px;
  background-color: #e6e6e6;
  padding: 5px;
  margin-bottom: 10px;
  .pp-title {
    font-size: 0.7em;
    small {
      font-size: 0.9em;
      float: right;
      font-weight: bold;
    }
  }
  .pp-interval {
    font-size: 0.6em;
    margin: 0.7em 0 0.4em 0;
  }
  .pp-delete {
    float: right;
    width: 14px;
    height: 14px;
    background-color: lightgrey;
    border-radius: 10px;
    padding: 2px 0 2px 1px;
    text-align: center;
    color: ${THEME.COLOR_SECONDARY};
    cursor: pointer;
  }
`;
//# sourceMappingURL=CasePaymentPlan.js.map